import { deferTracking, sendGAEvent } from '@noths/polaris-client-google-analytics';
import type { EventsMap } from '@noths/polaris-client-next-redux';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectCurrentMedia } from 'src/redux/productMediaCarousel/selectors';
import { actions } from 'src/redux/productMediaCarousel/slice';
import type {
  ProductMediaCarouselExpand,
  ProductMediaCarouselMediaClick,
  ProductMediaCarouselNavigate,
} from './events';

export const GAEventsMap: EventsMap<ReduxApplicationState> = {
  [actions.openModal.type]: (_prevState, _nextState, action) => {
    const {
      payload: { location },
    } = action as ReturnType<typeof actions.openModal>;

    deferTracking(() =>
      sendGAEvent<ProductMediaCarouselExpand>({
        event: 'custom_event',
        event_action: 'Expand media',
        event_category: 'Media carousel',
        event_label: location,
      }),
    );
  },
  [actions.setCurrentMedia.type]: (prevState, nextState, action) => {
    const {
      payload: { location, navigationType },
    } = action as ReturnType<typeof actions.setCurrentMedia>;

    if (location && navigationType === 'click') {
      deferTracking(() =>
        sendGAEvent<ProductMediaCarouselMediaClick>({
          event: 'custom_event',
          event_action: 'Media click',
          event_category: 'Media carousel',
          event_label: location,
        }),
      );
    }

    if (location && navigationType === 'swipe') {
      const direction: ProductMediaCarouselNavigate['event_action'] =
        selectCurrentMedia(nextState) > selectCurrentMedia(prevState)
          ? 'Next media'
          : 'Previous media';

      deferTracking(() =>
        sendGAEvent(<ProductMediaCarouselNavigate>{
          event: 'custom_event',
          event_action: direction,
          event_category: 'Media carousel',
          event_label: location,
        }),
      );
    }
  },
  [actions.nextMedia.type]: (_prevState, _nextState, action) => {
    const {
      payload: { location },
    } = action as ReturnType<typeof actions.nextMedia>;

    deferTracking(() =>
      sendGAEvent(<ProductMediaCarouselNavigate>{
        event: 'custom_event',
        event_action: 'Next media',
        event_category: 'Media carousel',
        event_label: location,
      }),
    );
  },
  [actions.prevMedia.type]: (_prevState, _nextState, action) => {
    const {
      payload: { location },
    } = action as ReturnType<typeof actions.prevMedia>;

    deferTracking(() =>
      sendGAEvent(<ProductMediaCarouselNavigate>{
        event: 'custom_event',
        event_action: 'Previous media',
        event_category: 'Media carousel',
        event_label: location,
      }),
    );
  },
};
